export const CART_HEADER_LOCAL_STORAGE_KEY = "cart_header_lottie";
export const BOLT_CART_HEADER_LOCAL_STORAGE_KEY = "bolt_cart_header_lottie";

export const TOING_STAMP_CONFIG = {
    imageAssetId: "TOING%20DARE%202%20COMPARE/Non%20compressed%20error/2x/stamp.png",
    width: 136,
    height: 130,
};

export const NO_ADDRESS_POPUP_TEXT = {
    TITLE: "Add or select delivery address to proceed",
    SUBTEXT: "",
    CTA: "Add or select address",
};

export const PRICE_COMPARISON_BANNER_CLICK_TRIGGER = "price_comparison_banner_click";

export const FREE_CASH_WARNING_POPUP_TEXT = {
    TITLE: "Free cash will be removed if you exit now!",
    DESCRIPTION: "Are you sure you want to exit?",
    SECONDARY_CTA: "Do not exit",
    PRIMARY_CTA: "Yes, exit",
};

export const FREE_CASH_ITEM_REMOVAL_POPUP_TEXT = {
    TITLE: "You'll lose free cash if you remove this item!",
    DESCRIPTION: "Are you sure you want to remove this item?",
    SECONDARY_CTA: "Don't remove",
    PRIMARY_CTA: "Remove",
};
